import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import SearchOffIcon from "@mui/icons-material/SearchOff";

function Error() {
  const { t } = useTranslation(["common"]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <SearchOffIcon
        sx={(theme) => ({
          fontSize: "100px",
          color: theme.system.colors.text.primary,
        })}
      />
      <Typography
        variant="h6"
        sx={(theme) => ({
          marginTop: "16px",
          textAlign: "center",
          fontSize: "16px",
          fontWeight: "bold",
          color: theme.system.colors.text.primary,
          fontFamily: theme.system.fonts.body,
        })}
      >
        {t("common:error.access_denied")}
      </Typography>
    </Box>
  );
}

export default Error;
